import type { MailboxInfo } from 'owa-client-types';
import getStore from '../store/store';
import { setLocalOverride } from '../utils/setLocalOverride';
import { applicationSettingsOverridesChanged } from './applicationSettingsOverridesChanged';

export default function setApplicationSettingOverrideAction(
    setting: string,
    value: any,
    mailboxInfo?: MailboxInfo
): void {
    setLocalOverride(setting, value, mailboxInfo);
    getStore(mailboxInfo).overrides[setting] = value;
    applicationSettingsOverridesChanged(mailboxInfo);
}
